import { INSURANCE_OFFERS_FROM_VITRINS } from '@sravni/ugc/lib/specialOffers/lists';
import type { InsuranceOffersFromVitrinsType } from '@sravni/ugc/lib/specialOffers/types';

import { getDmsConditions } from '../../helpers/conditions/insurance/dms';
import { getKriticheskieBolezniConditions } from '../../helpers/conditions/insurance/kriticheskieBolezni';
import { getStrahovanieDomovConditions } from '../../helpers/conditions/insurance/strahovanieDomov';
import { getStrahovkaOtKleschaConditions } from '../../helpers/conditions/insurance/strahovkaOtKlescha';
import type { OfferTab } from '../../helpers/getProductData';

export const insuranceProductsInfo: Record<InsuranceOffersFromVitrinsType, OfferTab> = {
  [INSURANCE_OFFERS_FROM_VITRINS.dms]: {
    key: { type: INSURANCE_OFFERS_FROM_VITRINS.dms },
    label: 'ДМС',
    generalLink: '/dms/',
    linkToOneProduct: '',
    getConditions: getDmsConditions,
    advertisingCategory: 'ДМС',
  },
  [INSURANCE_OFFERS_FROM_VITRINS['strahovka-kriticheskie-bolezni']]: {
    key: { type: INSURANCE_OFFERS_FROM_VITRINS['strahovka-kriticheskie-bolezni'] },
    label: 'Страхование от критических заболеваний',
    generalLink: '/strahovka-kriticheskie-bolezni/',
    linkToOneProduct: '',
    getConditions: getKriticheskieBolezniConditions,
    advertisingCategory: 'Страхование от критических заболеваний',
  },
  [INSURANCE_OFFERS_FROM_VITRINS['strahovanie-domov']]: {
    key: { type: INSURANCE_OFFERS_FROM_VITRINS['strahovanie-domov'] },
    label: 'Страхование домов',
    generalLink: '/strahovanie-domov/',
    linkToOneProduct: '',
    getConditions: getStrahovanieDomovConditions,
    advertisingCategory: 'Страхование домов',
  },
  [INSURANCE_OFFERS_FROM_VITRINS['strahovka-ot-klescha']]: {
    key: { type: INSURANCE_OFFERS_FROM_VITRINS['strahovka-ot-klescha'] },
    label: 'Страховка от укуса клеща',
    generalLink: '/strahovka-ot-klescha/',
    linkToOneProduct: '',
    getConditions: getStrahovkaOtKleschaConditions,
    advertisingCategory: 'Страховка от укуса клеща',
  },
};
